<div class="app-wrapper">
  <header class="app-header">
    <span class="app-title">
      <span *ngIf="selectedDesk">
        {{ selectedDesk?.name }}
      </span>
      <span *ngIf="selectedLocation">
        {{ selectedLocation?.name }} {{ selectedLocation?.numeration }}
      </span>
    </span>
    <div class="app-controls">
      <button *ngIf="selectedLocation && !selectedLocationClosed" class="btn btn-outline-red" (click)="closeLocation()">
        <span class="button-text">{{ 'advance.close location' | translate }}</span>
      </button>
      <button *ngIf="selectedLocation && selectedLocationClosed" class="btn btn-outline-green" (click)="openLocation()">
        <span class="button-text">{{ 'advance.open location' | translate }}</span>
      </button>
      <a class="settings-icon" (click)="goToAdmin()">
        <mat-icon>settings</mat-icon>
      </a>
    </div>
  </header>

  <div class="desk-container"
       [ngClass]="{
         'mobile-view-main': isMobileView && !isSidePanelVisibleOnMobile,
         'mobile-view-side': isMobileView && isSidePanelVisibleOnMobile
       }"
       *ngIf="selectedDesk || (selectedLocation && !selectedLocationClosed); else noDesk">

    <main class="main-panel" [class.is-flipped]="isFlipped">

      <div class="flip-content-front">
        <div class="panel-title panel-title--blue">
          <div *ngIf="currentDeskName">{{ currentDeskName }}</div>
          <div *ngIf="!currentDeskName">{{ 'control.current turn' | translate }}</div>
          <button class="list-toggle-button" *ngIf="isMobileView" (click)="toggleMobilePanelView()">
            <mat-icon>list</mat-icon>
          </button>
        </div>

        <div class="current-ticket-section">
          <div class="ticket-details" *ngIf="currentTurn; else noTicket">
            <span *ngIf="selectedLocation" class="ticket-label">{{ 'control.current turn' | translate }}</span>
            <h1 class="ticket-number">{{ (currentTurn && currentTurn != 'null') ? currentTurn : '-' }}</h1>
            <span *ngIf="currentCustomerName" class="data-label">{{ 'control.turn value' | translate }} - {{ currentCustomerName }}</span>
            <div class="timers">
              <span>{{ 'control.wait time' | translate }} {{ currentWaitingTime | formatTime }}</span>
              <span>{{ 'control.service time' | translate }} {{ currentServiceTime | formatTime }}</span>
            </div>
          </div>
          <ng-template #noTicket>
            <div class="no-ticket-placeholder">
              <h2>{{ 'control.no turn message1' | translate }}</h2>
              <p>{{ 'control.no turn message2' | translate }}</p>
            </div>
          </ng-template>
        </div>

        <div class="action-buttons">
          <div class="information-button-wrapper" *ngIf="selectedLocation">
            <button class="btn btn-outline" [disabled]="currentStatus !== 'ATTENDING'" (click)="toggleInformationMenu($event)">
              <mat-icon>add</mat-icon>
              {{ 'control.add service' | translate }}
            </button>
            <div class="options-menu information-menu" *ngIf="openInformationMenu" (click)="$event.stopPropagation()">
              <ul>
                <li *ngFor="let option of informationOptions" (click)="selectInformationOption(option)">
                  <mat-icon class="menu-item-icon">{{ option.icon }}</mat-icon>
                  <span>{{ option.value | translate }}</span>
                </li>
              </ul>
            </div>
          </div>
          <button class="btn btn-outline" [disabled]="currentStatus !== 'ATTENDING'" (click)="recall()">
            <mat-icon>refresh</mat-icon>
            {{ 'control.recall' | translate }}
          </button>
          <button [disabled]="selectedDesk || currentStatus !== 'ATTENDING'" class="btn btn-outline" (click)="requeue()">
            <mat-icon>low_priority</mat-icon>
            {{ 'control.requeue' | translate }}
          </button>
          <div class="transfer-button-wrapper">
            <button [disabled]="selectedDesk || currentStatus !== 'ATTENDING'" class="btn btn-outline" (click)="toggleTransferMenu($event)">
              <mat-icon>shortcut</mat-icon>
              {{ 'control.transfer' | translate }}
            </button>
            <div class="options-menu transfer-menu" *ngIf="openTransferMenu" (click)="$event.stopPropagation()">
              <ul>
                <li *ngFor="let transfer of transferOptions" (click)="transferTo(transfer)">
                  <mat-icon class="menu-item-icon">{{ transfer.icon }}</mat-icon>
                  <span>{{ transfer.value | translate }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="bottom-actions">
          <div class="primary-actions-group">
            <button class="btn btn-primary btn-large-main" (click)="callNextTurn($event)" (touchend)="callNextTurn($event)">
              <div class="btn-content">
                <mat-icon class="icon-next">turned_in_not</mat-icon>
                <span>{{ 'control.next turn' | translate }}</span>
              </div>
            </button>
            <button class="btn btn-primary btn-large-pause" [disabled]="!currentTurn" (click)="endTurn($event)" (touchend)="endTurn($event)">
              <mat-icon>pause_circle_outline</mat-icon>
            </button>
          </div>
          <div class="secondary-actions">
            <button class="btn btn-secondary" [disabled]="currentStatus !== 'ATTENDING'" (click)="clientAbsent()">
              <mat-icon>person_off</mat-icon>
              {{ 'control.client absent' | translate }}
            </button>
            <button class="btn btn-secondary" (click)="clientWithoutTicket()">
              <mat-icon>warning</mat-icon>
              {{ 'control.no ticket' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="flip-content-back">
        <div class="panel-title panel-title--blue">
          <button class="back-button" (click)="flipBack()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <h1 *ngIf="!selectedTransferMode">
            {{ 'control.no ticket title' | translate }}
          </h1>
          <h1 *ngIf="selectedTransferMode">
            {{ 'control.transfer to title' | translate }}
          </h1>
        </div>
        <div class="flip-back-body">
          <div *ngIf="selectedTransferMode !== 'LOCATION'" class="service-list">
            <div class="service-item" *ngFor="let service of allServices">
              <div class="item-header">
                <span class="item-header-identifier">
                  {{ service.name }}
                </span>
              </div>
              <div class="item-body">
                <button class="btn btn-primary action-button" (click)="attendInService(service.internalId)">
                  <span class="button-text">{{ 'global.select' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="selectedTransferMode === 'LOCATION'" class="service-list">
            <div class="service-item" *ngFor="let location of allLocations">
              <div class="item-header">
                <span class="item-header-identifier">
                  {{ location.name }} {{ location.numeration }}
                </span>
              </div>
              <div class="item-body">
                <button class="btn btn-primary action-button" (click)="attendInLocation(location.internalId)">
                  <span class="button-text">{{ 'global.select' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </main>

    <aside class="side-panel">
      <div class="panel-title panel-title--green">
        <button class="back-button" *ngIf="isMobileView" (click)="toggleMobilePanelView()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        {{ pendingTurns.length }} {{ 'control.pending turns' | translate }}
      </div>

      <ng-container *ngIf="pendingTurns && pendingTurns.length > 0; else noPendingTurns">
        <ul class="ticket-list">
          <li *ngFor="let turn of pendingTurns" class="ticket-list-item">
            <div class="ticket-info">
              <div class="ticket-main-info">
                <span class="ticket-list-number">{{ turn.turn }}</span>
                <span class="ticket-list-service">{{ turn.deskName }}</span>
              </div>
              <div class="ticket-secondary-info">
                <span class="ticket-list-initial-time">{{ turn.turnDate | dateUnixTransformer: 'true' }}</span>
                <span class="separator">-</span>
                <span class="ticket-list-wait-label">{{ 'control.wait' | translate }} {{ turn.waitingTimeSeconds | formatTime }}</span>
              </div>
              <div *ngIf="turn.customerName" class="ticket-secondary-info">
                <span class="ticket-list-initial-time">{{ 'control.turn value' | translate }}</span>
                <span class="separator">-</span>
                <span class="ticket-list-wait-label">{{ turn.customerName }}</span>
              </div>
              <div *ngIf="turn.turnLocation" class="ticket-secondary-info">
                <mat-icon>shortcut</mat-icon>
                <span class="ticket-list-wait-label">{{ turn.turnLocation }}</span>
              </div>
            </div>
            <span *ngIf="selectedLocation" class="more-options" (click)="toggleMenu(turn, $event)">
              <mat-icon>more_vert</mat-icon>
              <div class="options-menu more-options-menu" *ngIf="openMenuTurnId === turn.turn">
                <ul>
                  <li (click)="callSelectedTurn(turn)">{{ 'control.call' | translate }}</li>
                </ul>
              </div>
            </span>
          </li>
        </ul>
      </ng-container>

      <ng-template #noPendingTurns>
        <div class="empty-list-placeholder">
          <mat-icon>hourglass_empty</mat-icon>
          <h2>{{ 'control.no pending turns' | translate }}</h2>
          <p>{{ 'control.list will update' | translate }}</p>
        </div>
      </ng-template>
    </aside>

  </div>

  <ng-template #noDesk>
    <main class="no-ticket-placeholder">
      <div id="missingConfig">
        <h2 [style.display]="!selectedDesk && !selectedLocation ? 'block' : 'none'">
          {{ 'advance.error no selection' | translate }}
        </h2>
        <h2 [style.display]="selectedLocation && selectedLocationClosed ? 'block' : 'none'">
          {{ 'advance.error open location' | translate }}
        </h2>
      </div>
    </main>
  </ng-template>

  <div class="footer-branding">
    <span>Powered by </span>
    <img src="assets/images/mturn_logo.svg" class="footer-logo" alt="mTurn Logo">
  </div>
  <h5>v{{ version }}</h5>
</div>
